import { combineReducers, compose } from '@reduxjs/toolkit';

import slice from './projects.slice';
import projectsAdapter from './projects.adapter';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

// Localized Selectors
export const selectProjectsStatus = (state: LocalState) => state.status;
export const selectProjectRestoreStatus = (state: LocalState) => state.restoreStatus;

/**
 * Globalized selectors that know how to select data from the RootState
 */
export default {
  ...projectsAdapter.getSelectors(localState),
  status: compose(selectProjectsStatus, localState),
  restoreStatus: compose(selectProjectRestoreStatus, localState),
};
